<!--
 * @Author: your name
 * @Date: 2020-02-18 14:46:27
 * @LastEditTime: 2020-04-10 10:39:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/List.vue
 -->
<template>
   <div class="list" :style="`background: url('${require('../assets/bg20.png')}'); background-size: 100% 100%;`">
    <!-- <img class="sub-logo" src="../assets/logo4.png"> -->
    <img class="sub-logo2" src="../assets/logo5.png">
    <div class="body">
        <div class="content">
            <div class="title" @click="goVideoList(9)">员工关爱课程</div>
            <div class="title" @click="goQuestion(3)">症状自评量表-SCL90</div>
            <div class="title" @click="goQuestion(1)">焦虑自评量表-SAS</div>
            <div class="title" @click="goQuestion(2)">抑郁自评量表-SDS</div>
        </div>
    </div>
    <share></share>
    <div class="var_popup">
        <van-popup v-model="show" class="privacy">
          <div class="title">
            <img  src="../assets/head3.png" >
          </div>
          <div class="content">
            <div class="contentInner">
          欢迎您参与心理测试调查问卷（以下简称“问卷”），当您访问我们问卷时，请仔细阅读知情同意书及个人信息隐私声明，我们会按照隐私声明条款收集、使用您的个人信息并予以保护。
            <p>请您完整阅读本知情同意书及个人信息隐私声明后，点击勾选“我已阅读同意”，一旦接受此知情同意书及个人隐私声明，将视作同意以下相关条款内容并准许平台收集您的个人信息。</p>
            <p>一：知情同意书</p>
            <p>为了给参与者提供专业、有效、安全的心理测试调查问卷服务，维护参与者和平台权益，保证调查问卷的顺利进行，现就心理调查问卷的基本原则、参与者和平台的权利和义务做如下说明：</p>
            <p>1、心理调查问卷的基本原则：</p>
            <p>2020年1月27日，国家卫健委印发的《新型冠状病毒感染的肺炎疫情紧急心理危机干预指导原则》，除确诊和疑似患者等，连医护及相关人员也被列入当中，这标志着中国正式启动了对所有敏感人群提供心理健康保护的指南，为了解新型冠状病毒肺炎对我们的心理影响，更加积极地应对疫情，星空学院特开设 “医务人员心理关爱”板块，以助力打赢心理防疫战。</p>
            <p>2、参与者的权利与义务</p>
            <p>1)	根据个人情况填写相关调查问卷，以积极的态度对待问卷结果</p>
            <p>2)	自愿，参与调查者有权决定中止或结束问卷。</p>
            <p>3)	参与调查者须提供其真实姓名及联系方式，这些资料仅用于心理调查问卷中的档案管理，不会透漏给其他任何单位和个人。</p>
            <p>3、平台的权利与义务</p>
            <p>1)	参与者的个人信息及调查问卷的相关问题不会被随意谈论，测试过程中，参与者的所有信息都严格保密。只有工作人员才能察看相关医疗纪录，以便核查所收集信息的准确性，并确保本问卷正常进行。</p>
            <p>2)	参与者完成调查问卷后的相关医疗机构推荐，参与者有权利选择或不选择推荐的医疗机构，平台不得做强制推荐。</p>
            <p>4、本次问卷分为《症状自评量表SCL90》、《焦虑自评量表-SAS》、《抑郁自评量表-SDS》，请根据参与者的个人实际情况完成测试。</p>
            <p>二. 个人信息隐私声明</p>
            <p>1、我们会对参与者的个人信息严格保密。并采取适当的技术措施和其他必要手段，确保信息安全，以防止该个人信息的泄漏和丢失。如您不同意您的个人信息按本隐私声明的规定进行收集和使用，请停止向我们提供您的个人信息，并请结束本调查问卷。</p>
            <p>2、为了提供专业、有效、安全的心理咨询服务，根据测试内容要求，需主动向我们提供相关个人信息，例如您的真实姓名、联系方式等。</p>
          
              </div>
          </div>
          <div class="bottom_top"></div>
          <van-row class="bottom" type="flex" justify="center">
              <van-checkbox v-model="checked" shape="square" class="agree">我已阅读同意</van-checkbox>
          </van-row>
          <div>
              <van-row class="bottom" type="flex" justify="center">
                  <van-col>
                      <van-button type="primary"  class="cancel" @click="cancelPrivacy()">取消</van-button>
                      <van-button type="info" class="confirm" @click="confirmPrivacy()">确认</van-button>
                  </van-col>
              </van-row>
          </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Http } from "@/utils/http.js"
import api from "@/config/api.js"
import Cookies from 'js-cookie'

export default {
  name: 'List',
  data() {
    return {
      show: false, // 隐私条款显示
      choose: false,
      registered: false,
      login: false,
      checked: false,
      name: '',
      unit_name: '',
      city: '',
      tel: '',
      sex: '',
      unit: '',
      mechanism: '',
      repeatClick: false,
      uid: '', // 用户ID
      showPicker: false,
      id : 1, // 问题ID
      privacy: '', // 隐私是否同意过
    }
  },

  methods: {
    // 跳转到视频详情页
    goVideoList (id) {
       this.$router.push({ name: "ListShow", query: { id: id } });
    },
    // 答题
    goQuestion(id){
      this.id  = id
      // 显示隐私
      if(!this.privacy){
        this.show = true
        return 
      }
      // switch(id){
      //       case 1: 
      //           this.$router.push({ name: "Question1" })
      //           break;
      //       case 2: 
      //           this.$router.push({ name: "Question2" })
      //           break;
      //       case 3: 
      //           this.$router.push({ name: "Question3" })
      //           break;
      //   }

      switch(id){
            case 1: 
                this.$router.push({ name: "Statement", query: { id: 1 }  })
                break;
            case 2: 
                 this.$router.push({ name: "Statement", query: { id: 2 }  })
                break;
            case 3: 
                 this.$router.push({ name: "Statement", query: { id: 3 }  })
                break;
        }
    },
    // 显示隐私
    showPrivacy () {
      this.show = true
    },
     // 取消隐私
    cancelPrivacy () {
      this.show = false
    },
    // 弹框
    customAlert (msg) {
      this.$dialog.alert({
        message: msg
      })
    },
    // 确认隐私
    confirmPrivacy () {
      // 判断是否点击确认按钮
      if (!this.checked) {
        this.customAlert('请点击隐私确认')
        return 
      }
      this.show = false
      // 记入已经确认过隐私
      Cookies.set('privacy', 1, { expires: 240 })
      // 跳到答题页
      const id = this.id
       switch(id){
            case 1: 
                this.$router.push({ name: "Question1" })
                break;
            case 2: 
                this.$router.push({ name: "Question2" })
                break;
            case 3: 
                this.$router.push({ name: "Question3" })
                break;
        }
    },
  },
  mounted: function () {
    this.uid = Cookies.get('uid')
    this.privacy = Cookies.get('privacy')
    document.title = '医务人员心理关爱'
  }
}
</script>

<style lang="less">
.sub-logo {
    position: absolute;
    width: 100px;
    top: 20px;
    left: 20px;    
}
.sub-logo2 {
    position: absolute;
    width: 40px;
    top: 20px;
    right: 20px;    
}
.list {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    .body {
        flex:1;
        margin-top: 300px;
        .title {
          background: #fff;
          border-radius: 24px;
          border: 4px solid;
          color: #33b0e6;
          margin: 0 55px 10px;
          font-size: 18px;
          text-align: center;
          height: 40px;
          line-height: 40px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          font-weight: bold;
        }
    }

    .var_popup{
      .privacy {
        width: calc(100% - 40px);
        border-radius: 4px;
        .title{
          img {
            width: 100%;
          }
        }
        .content{
          font-size: 16px;
          line-height: 24px;
          height: 280px;
          position: relative;
          overflow: hidden;
          margin: 0 20px;
          word-break: break-all;
          .contentInner {
              position: absolute;
              left: 0;
              top: 0;
              // right: -17px;
              bottom: 0;
              overflow-x: hidden;
              overflow-y: scroll;
          }
        }
        .agree {
          font-size: 12px;
          
        }
        .bottom_top {
            width: 90%;
            height: 1px;
            border-top: dashed #33b0e6 1px;
            margin: 0 auto;
        }
        .bottom {
            margin-top: 20px;
            margin-bottom: 12px; 
            .van-checkbox__label {
              color: #028fe1 !important;
              font-size: 16px;
            }
            .van-checkbox__icon--checked .van-icon {
              border-radius: 4px;
              background-color: transparent;
              color: #028fe1 !important;
            }
            .cancel, .confirm {
              width: 110px;
              height: 50px;
              border-radius: 8px;
              font-size: 16px;
              border: none;
            }
            .confirm {
              background-color: #0090e2;
            }
            .cancel {
              background-color: #d2d2d2;
            }
            
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionList.vue